import React, { useState } from 'react';

import classNames from 'classnames';
import NavBackIcon from 'icons/ic-nav-back.svg';
import ProgressIcon from 'icons/progress.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';

import { useCurrentActor } from 'components/contexts/CurrentActor';
import { useProjectCoshhContext } from 'components/contexts/ProjectCoshhContext';
import { useBreadBoard } from 'components/contexts/Toaster';

export default function MasterCoshhBackButton({ hasCoshhDocumentBeenChanged }) {
  const breadBoard = useBreadBoard();
  const currentActor = useCurrentActor();

  const { projectId } = useProjectCoshhContext();

  const [isLoading, setIsLoading] = useState(false);

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'masterCoshh.components.MasterCoshhBackButton',
  });

  const handleOnClick = () => {
    setIsLoading(true);

    if (hasCoshhDocumentBeenChanged) {
      axios
        .post(`/projects/${projectId}/latest_history/versions`, {
          success_toast_message: i18nT('successToastMessage'),
          failure_toast_message: i18nT('failureToastMessage'),
        })
        .then(() => {
          window.location.href = `/projects/${projectId}?switch_tab=coshh-tab`;
        })
        .catch(() => {
          breadBoard.addInedibleToast();
          setIsLoading(false);
        });
    } else {
      window.location.href = `/projects/${projectId}?switch_tab=coshh-tab`;
    }
  };

  return (
    <OutlinedButton
      className='nav-button no-back-warning'
      color='blue-grey'
      onClick={isLoading ? () => {} : handleOnClick}
      onDark={true}
      size='md'
    >
      <NavBackIcon className='tw-mr-1 tw-pt-0.5' height={12} width={12} />
      {i18nT('button', {
        interpolation: { escapeValue: false },
        singularRAMSName: currentActor.division.attributes.singularRAMSName,
      })}
      <ProgressIcon
        className={classNames(
          'tw-ml-1.5',
          isLoading ? 'tw-inline-block' : 'tw-hidden',
        )}
      />
    </OutlinedButton>
  );
}

MasterCoshhBackButton.propTypes = {
  hasCoshhDocumentBeenChanged: PropTypes.bool.isRequired,
};
